/**
 * @generated SignedSource<<16aed0f267a461532e8345a03da7ae35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunNovaAgentDryRunInput = {
  id: string;
  taskId: string;
  message?: string | null;
  threadId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RunNovaAgentDryRunMutation$variables = {
  input: RunNovaAgentDryRunInput;
};
export type RunNovaAgentDryRunMutation$data = {
  readonly runNovaAgentDryRun: {
    readonly result: {
      readonly output: string | null;
      readonly ranAt: string | null;
      readonly run: {
        readonly threadId: string | null;
        readonly modelDisplayName: string | null;
      } | null;
    } | null;
  } | null;
};
export type RunNovaAgentDryRunMutation = {
  variables: RunNovaAgentDryRunMutation$variables;
  response: RunNovaAgentDryRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "output",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ranAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelDisplayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunNovaAgentDryRunMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentDryRunPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentDryRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaDryRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunNovaAgentDryRunMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RunNovaAgentDryRunPayload",
        "kind": "LinkedField",
        "name": "runNovaAgentDryRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaDryRunResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentRun",
                "kind": "LinkedField",
                "name": "run",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d89338bc4872510bc37f61c6ca0ffb3f",
    "id": null,
    "metadata": {},
    "name": "RunNovaAgentDryRunMutation",
    "operationKind": "mutation",
    "text": "mutation RunNovaAgentDryRunMutation(\n  $input: RunNovaAgentDryRunInput!\n) {\n  runNovaAgentDryRun(input: $input) {\n    result {\n      output\n      ranAt\n      run {\n        threadId\n        modelDisplayName\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b6187615e32d41d2479285f0dc083dc";

export default node;
